module.exports = __webpack_public_path__ + "static/media/bg-1.ba79b83c.png";